import React from 'react';
import colors from 'config/colors';
import FieldLabel from './FieldLabel';

interface CostCentreFieldProps {
  costCentre: { code: string, description: string, careGroup: string } | null
}

const valueContainerStyle = {
  alignItems: 'center',
  color: colors.text,
  display: 'flex',
  fontSize: '0.9rem',
  lineHeight: 1.3,
  minHeight: 30,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};
const missingValueStyle = { color: colors.dagny.error, fontSize: '0.9rem', fontWeight: 500 };

function CostCentreField(props: CostCentreFieldProps) {
  return (
    <FieldLabel label="Cost Centre">
      <div style={valueContainerStyle}>
        {props.costCentre ?
          <p>{props.costCentre.code} | {props.costCentre.description}</p>
          :
          <p style={missingValueStyle}>None</p>
        }
      </div>
    </FieldLabel>
  );
}

export default React.memo(CostCentreField);
